import { DeepPartial, TermSuggestionsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SUGGESTIONS_CONFIG: DeepPartial<TermSuggestionsConfig> = {
  size: 5
};
